import React from 'react';
import {
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  CondensedLabel,
  Layout,
} from '@axiom/ui';

export type ChatHistorySectionProps = {
  children: React.ReactNode;
  defaultOpen?: boolean;
  label: string;
  name: string;
};

export const ChatHistorySection = ({
  children,
  defaultOpen = false,
  label,
  name,
}: ChatHistorySectionProps) => {
  return (
    <AccordionsItem expanded={defaultOpen} name={`${name}_SECTION`}>
      <AccordionsItemHeader name={name}>
        <CondensedLabel as="span">{label}</CondensedLabel>
      </AccordionsItemHeader>

      <AccordionsItemSection keepMounted name={`${name}_LIST`}>
        <Layout direction="vertical" verticalGutter="8px">
          {children}
        </Layout>
      </AccordionsItemSection>
    </AccordionsItem>
  );
};
